"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lock_1 = require("../icons/lock");
exports.default = lock_1.Lock;
